import http from '../plugins/axios'

export const getReviews = async (params) => {
  try {
    const response = await http.get(`/api/v2/reviews`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}
